export default __webpack_public_path__ + "static/media/bs-coat-of-arms.bb54f8a8.png";